/**
 * tailwind-merge, taught the shared theme.
 *
 * tailwind-merge decides which of two conflicting utilities wins by class
 * group, and it only knows Tailwind's default names. A theme step it has not
 * been told about falls into the nearest guess: `text-mini` is not a t-shirt
 * size, so it is filed as a text colour and silently discards `text-fg-muted`
 * beside it; `shadow-overlay` is filed as a shadow colour. Every `cn` in the
 * monorepo merges through this instance so the named steps in
 * shared-styles.css are first-class.
 */
import { extendTailwindMerge } from "tailwind-merge";

/** @type {import("tailwind-merge").ConfigExtension<string, string>} */
export const designTokenMergeConfig = {
  extend: {
    theme: {
      // Font sizes added to Tailwind's scale (`--text-*` in shared-styles.css).
      text: ["micro", "mini", "compact"],
      // Named elevation recipes (`--shadow-*` in shared-styles.css).
      shadow: ["raised", "overlay", "modal"],
      // Radius scale is Tailwind's names at our sizes, plus pill.
      radius: ["pill"],
    },
  },
};

export const twMerge = extendTailwindMerge(designTokenMergeConfig);
